import * as React from 'react';
import type { SVGProps } from 'react';
const SvgApplications = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M6.213 5.92a1 1 0 1 0 0 2 1 1 0 0 0 0-2m1.85 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m3.85-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
    <path
      fillRule="evenodd"
      d="M4.707 16.664h10.586c.375 0 .728 0 1.017-.039.322-.043.673-.146.964-.437.29-.29.394-.642.437-.964.04-.289.04-.642.039-1.017V5.794c0-.375 0-.728-.039-1.017-.043-.322-.146-.673-.437-.964-.29-.29-.643-.394-.964-.437-.289-.04-.642-.04-1.017-.04H4.707c-.375 0-.728 0-1.017.04-.321.043-.673.146-.964.437-.29.29-.394.642-.437.964-.04.289-.04.642-.039 1.017v8.413c0 .375 0 .728.039 1.017.043.322.146.674.437.964.29.29.643.394.964.437.289.04.642.04 1.017.04Zm-.914-1.543a1 1 0 0 0 .097.018c.177.024.426.025.86.025h10.5c.434 0 .684-.002.86-.025a1 1 0 0 0 .097-.018 1 1 0 0 0 .018-.097c.023-.176.025-.426.025-.86V9.65H3.75v4.515c0 .434.002.684.025.86a1 1 0 0 0 .018.097ZM3.75 8.649h12.5V5.837c0-.434-.002-.684-.025-.86a1 1 0 0 0-.018-.097 1 1 0 0 0-.097-.018c-.176-.023-.426-.025-.86-.025H4.75c-.434 0-.683.002-.86.025a1 1 0 0 0-.097.018 1 1 0 0 0-.018.097c-.023.176-.025.426-.025.86z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgApplications;
